export default "__VITE_ASSET__CFMW_AUm__"